module.exports = __webpack_public_path__ + "static/media/21GalleryPuppets.bd45a24e.jpeg";